import { render, staticRenderFns } from "./PDFBase.vue?vue&type=template&id=2184fab9&scoped=true&"
import script from "./PDFBase.vue?vue&type=script&lang=js&"
export * from "./PDFBase.vue?vue&type=script&lang=js&"
import style0 from "./PDFBase.vue?vue&type=style&index=0&id=2184fab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184fab9",
  null
  
)

export default component.exports